import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaScheduleTimeContainer = styled(Flexbox)`
    width: 254px;
    overflow: hidden;
`

export const StyledAgendaScheduleTime = styled.p(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textSm};
        padding: ${spacing}px 0;
        color: ${palette.neutral['600']};
        width: 84px;
    `
)
